export default {
  User: 'User',
  Vessel: 'Vessel',
  VesselTrial: 'VesselTrial',
  VesselTrialTest: 'VesselTrialtest',
  VesselMachine: 'VesselMachine',
  VesselMachineTrial: 'VesselMachineTrial',
  VesselCrew: 'VesselCrew',
  VesselMachineTest: 'VesselMachineTest',
  VesselReferenceSensor: 'VesselReferenceSensor',
  VesselSwitchboardConfig: 'VesselSwitchboardConfig',
  VesselThruster: 'VesselThruster'
}
